import React from 'react';
import { Fab, type FabProps } from '@mui/material';
import { Add } from '@mui/icons-material';

export interface AppTableAddFabProps {
  onClick: () => void;
  /** Accessible label and tooltip text */
  label?: string;
  disabled?: boolean;
  color?: FabProps['color'];
  size?: FabProps['size'];
  /**
   * `container` (default): bottom-right of the nearest positioned ancestor (e.g. EnhancedTable).
   * `viewport`: fixed to the browser window — use when the page panel does not fill the screen.
   */
  anchor?: 'container' | 'viewport';
  /** Distance from bottom of table panel; use a larger value when pagination is visible. */
  bottomOffset?: number;
  sx?: FabProps['sx'];
}

/** Circular “+” FAB anchored to the bottom-right of a table panel (Android-style add). */
const AppTableAddFab: React.FC<AppTableAddFabProps> = ({
  onClick,
  label = 'Add',
  disabled = false,
  color = 'primary',
  size = 'medium',
  anchor = 'container',
  bottomOffset,
  sx,
}) => (
  <Fab
    color={color}
    size={size}
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={label}
    sx={[
      {
        position: anchor === 'viewport' ? 'fixed' : 'absolute',
        bottom: bottomOffset ?? ((theme) => theme.spacing(2)),
        right: (theme) => theme.spacing(2),
        zIndex: (theme) => (anchor === 'viewport' ? theme.zIndex.fab : 2),
        boxShadow: (theme) => theme.shadows[6],
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    <Add />
  </Fab>
);

export default AppTableAddFab;
